import React from "react";


const Net = () => {
return(
    
<>

<section class="about1" id="">

<div class="max-width" >
{/* <!-- <h2 class="title">About me</h2> --> */}
<div class="about-content">

<div class=" right">
<div class="text">.NET</div>
<h3>Hire the best .NET Developers in Mumbai<br/>
<span>Hire ShellCode Solutions, the best .NET developers in Mumbai, for your software requirements.<br/>
Coding and Deploying made easy!<br/>
Customizable .NET Software<br/>
Client retention and satisfaction<br/>
Ranging across industries<br/>
On-Time Delivery
</span>
</h3>
</div>
<div class=" left">
<img src="assets/images/1.png" alt="1"/>
</div>
</div>

</div>
</section>
<div className="extra">    
    <h3>.NET Services we provide:<span>
        Custom .NET Development: ShellCode Solutions, the best .NET developers in Mumbai, prioritizes your needs and delivers flexible and customizable project models.<br/>
        .NET MVC Development: Our developers deliver smooth and modern websites using the latest MVC Development methods.<br/>
        Enterprise .NET Solutions: We construct Enterprise .NET Solutions based on the ASP.NET framework that maximizes productivity and revenue.<br/>
        .NET CMS Solutions: We build dynamic websites with integrated .NET CMS Solutions which helps you optimize the experience of your consumers.<br/>
        .NET eCommerce Development: Get the best eCommerce websites delivered at your doorstep using the latest .NET Technology and reign in the digital market.<br/>
        .NET Migration: The designers at ShellCode Solutions migrate your web and mobile applications to .NET in a seamless and hassle-free manner.<br/></span>
    </h3>

    <h3>Why hire the best .NET developers in Mumbai<br/><span>
    Our skilled and experienced employees work efficiently to provide you the best .NET Development solutions in Mumbai.<br/>
    Stay in the loop!: Stay updated on our day-to-day progress. Enjoy a completely transparent process at ShellCode Solutions.<br/>
    On-Time Delivery: Get your project the day you desire. We are never late!<br/>
    MVC Customizations: Monitor performance and accendibility using ASP.NET MVC Customizations.<br/>
    Architecture Consulting: Our efficient developers also provide Architecture Consulting along with the best .NET development services.<br/>
    Cost Efficiency: The perks of using cutting-edge technology for your .NET Development requirements are economical costs and maximum efficiency.<br/>
    Maintenance and Support: For us, our job never ends. Even after launch, we provide constant support whenever you need us.
    </span></h3>
    <h3>Best .NET Development in Mumbai across industries<br/><span>
    Our wide range of .NET Development projects covers all industries and niches. .NET’s flexibility makes it perfect for usage across various industries so that you can get the best irrespective of your field of work. Benefit from our custom .NET development services.
    </span></h3>

    <h3>Our Tools and Technologies<br/><span>
    Our skilled .NET developers make robust use of the latest tools and technology provided to them by the best .NET Development Company in Mumbai to offer you a seamless experience.
    Choose from a variety of engagement models<br/>
    We know that no two projects are similar. That is why we offer customizable engagement models and services for you to choose from.<br/>
    </span></h3>

</div>
    </>
)
}

export default Net;
